module.exports = __webpack_public_path__ + "static/loader-9eb56725484751304dde3480aefc8565.gif";